import { useEffect, useState } from "react";

const ITEMS_POR_PAGINA = 9;

const UsePagination = (campos) => {
    const [camposActuales, setCamposActuales] = useState([])
    const [items, setItems] = useState([])
    const [paginaActual, setPaginaActual] = useState(0)

    useEffect(() => {
        setCamposActuales(campos)
        setItems([...campos].splice(0, ITEMS_POR_PAGINA))
    }, [campos])

    const handleSiguiente = () => {
        const totalElementos = camposActuales.length;
        const paginaSiguiente = paginaActual + 1;
        const primerIndex = paginaSiguiente * ITEMS_POR_PAGINA;

        if (primerIndex >= totalElementos) return;

        setItems([...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA))
        setPaginaActual(paginaSiguiente)
    }

    const handleRegresar = () => {
        const paginaAnterior = paginaActual - 1;

        if (paginaAnterior < 0) return;
        const primerIndex = paginaAnterior * ITEMS_POR_PAGINA;

        setItems([...camposActuales].splice(primerIndex, ITEMS_POR_PAGINA))
        setPaginaActual(paginaAnterior)

    }

    return {
        handleRegresar,
        handleSiguiente,
        items
    }
}

export default UsePagination